import { PanelLeftClose, PanelLeftOpen } from '@orgus/ui/icons';
import { NavLink } from 'react-router';
import { IconButton, OrgusLockup } from '@orgus/ui';
import { usePrefs } from '../../lib/prefs.ts';
import { COMPACT_RAIL_QUERY, useMediaQuery } from '../../lib/useMediaQuery.ts';
import { useRailSheet } from './railSheet.ts';

/**
 * The installed desktop app's title bar (Window Controls Overlay): one strip across the whole
 * window with the brand and the sidebar toggle in it. The operating system sets its height and
 * where the window buttons sit (right on Windows and most Linux desktops, left as traffic lights
 * on macOS), so it starts after the buttons on the left and ends before them on the right. The
 * mark keeps one gap to the top, bottom and left edges (titlebar-strip in styles/index.css), on
 * every system. A browser tab and a window with the system title bar do not show it.
 */
export function TitleBar() {
  const prefCollapsed = usePrefs((s) => s.railCollapsed);
  const toggleRail = usePrefs((s) => s.toggleRail);
  const narrow = useMediaQuery(COMPACT_RAIL_QUERY);
  const openSheet = useRailSheet((s) => s.setOpen);
  const collapsed = narrow || prefCollapsed;

  return (
    <div className="titlebar titlebar-strip hidden h-(--titlebar-height) shrink-0 items-center gap-2 bg-rail wco:flex">
      <NavLink to="/" aria-label="Orgus, go to Overview" className="flex items-center rounded-control text-fg outline-offset-2">
        <OrgusLockup layout="compact" capHeight={8.25} decorative />
      </NavLink>
      <IconButton
        label={narrow ? 'Open sidebar' : collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        icon={collapsed ? <PanelLeftOpen /> : <PanelLeftClose />}
        shortcut={narrow ? undefined : ['[']}
        size="xs"
        tooltipSide="bottom"
        onClick={narrow ? () => openSheet(true) : toggleRail}
      />
    </div>
  );
}
